const motifs = Object.freeze({
  calcium_motifs: {
    eloopf: "x{DNQ}x(2){GP}{ENPQS}x(2){DPQR}[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED][FLYMVIW]x(2){NPS}{DENQ}x(3)",
    eloop: "x{DNQ}x(2){GP}{ENPQS}x(2){DPQR}[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED]",
    loopf: "[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED][FLYMVIW]x(2){NPS}{DENQ}x(3)",
    loop: "[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED]",
    PC: "[LMVITNF][FY]x(2)[YHIVF][SAITV]x(5,9)[LIVM]x(3)[EDS][LFM][KRQLE]x(20,28)[LQKF][DNG]x[DNSC]x[DNK]x(4)[FY]x[EKS]",
    Pseudo:"[LMVITNF][FY]x(2)[YHIVF][SAITV]x(5,9)[LIVM]x(3)[EDS][LFM][KRQLE]",
    Excalibur: "DxDxDGx(2)CE",
    EF_hand_like:"Dx[DNS]{ILVFYW}[DEN]G{GP}x(5,6)[DE]",
    SP00018: "Dx[DNS]{ILVFYW}[DENSTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[DE][LIVMFYW]",
    PS00303:"[LIVMFYW](2)x(2)[LK]Dx(3)[DN]x(3)[DNSG][FY]x[ES][FYVC]x(2)[LIVMFS][LIVMF]"
  },
  cholesterol_motifs: {
    CARC: "[KR]-x(1,5)-[YF]-x(1,5)-[LV]",
    CRAC: "[LV]-x(1,5)-Y-x(1,5)-[KR]"
  },
  enth_motifs: {
    ENTH_domain:"N-x(11,13)-V-x(2)-A-T-x(34,36)-R-x(7,8)-W-R-x(3)-K-x(11)-G-x-E-x(15)-L-x(10,11)-D-x-G-x(3)-R-x(11)-D-x(7)-R"
  },
  phosphoinositide_motifs: {
    phosphoinositide_binding_motif_1:"[KR]-x(4)-K-x-[KR](2)",
    phosphoinositide_binding_motif_2:"GKRLKKKKTTVKKK"
  },
  gQuadruplex_motifs: {
    G_Quadruplex_Pattern_1:"[G](2,7)-x(1,7)-[G](2,7)-x(1,7)-[G](2,7)",
		G_Quadruplex_Pattern_2:"[G](3,5)-x(1,7)-[G](3,5)-x(1,7)-[G](3,5)-x(1,7)-[G](3,5)"
  },
  zinc_motifs: {
    TFIIIA_type:"C-x(2,5)-C-x(12,13)-H-x(2,5)-H",
		SHR_Type:"C-x(2,5)-C-x(12,15)-C-x(2,5)-C-x(15,16)-C-x(4,5)-C-x(8,10)-C-x2,3-C",
		PS00028:"C-x(2,4)-C-x(3)-[LIVMFYWC]-x(8)-H-x(3,5)-H"
  }

});

export default motifs;